import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Subfooter from './Subfooter';

const Firm = () => {
    useEffect(() =>{
        document.title = "Firm | Rich-Oak Group"
    },[])

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="firmfirstbox">
    <Row >
    <div className="col-lg-7 col-md-12">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">The Firm</h3>
        <p className='description hmfirstboxdescription'>
        Rich-Oak invests in building businesses that can produce long-term competitive advantage which yields competitive returns, improve lives and economic growth for our investors, customers and other stakeholders.

        </p>
        
       
  
        </div>
    </div>
    </Row>
    </div>



    <div className='hmsecondbox'>
    {/* <div className='hmsecondinnerbox'>

 

        <Container>
            <Row>
                <div className='col-md-2 col-6'>
                <img className=""  style={{height:"32px",width:"100px"}} src="images/partners/remita.png"/>
                    </div>

                    <div className='col-md-2 col-6'>
                <img className="" style={{height:"32px",width:"100px"}} src="images/partners/remita.png"/>

                    </div>

                    <div className='col-md-2 col-6'>
                <img className="" style={{height:"32px",width:"100px"}}  src="images/partners/remita.png"/>
                    </div>

                    <div className='col-md-2 col-6'>
                <img className="" style={{height:"32px",width:"100px"}}  src="images/partners/remita.png"/>

                    </div>

                    <div className='col-md-2 col-6'>
                    <img className="" style={{height:"32px",width:"100px"}}  src="images/partners/remita.png"/>

                    </div>

                    <div className='col-md-2 col-6'>
                    <img className="" style={{height:"32px",width:"100px"}}  src="images/partners/remita.png"/>


                    </div>
                
            </Row>
        </Container>
        </div> */}
    </div>


    <div className='hmthirdbox'>
    <div className=''>
        {/* <Container> */}
            <Row>
                <div className='col-md-6'>
                <img class="img-fluid"   src="images/history.jpg"/> 
                {/* <iframe className="img-fluid" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> */}
                    </div>

                    {/* <div className='col-md-1'></div> */}

                    <div className='col-md-6'>
                    <h1 className="hmwwd"><span style={{color:"#D80032"}}> Our </span> History</h1>
                    {/* <hr class="hpwwdhr1"/> */}
                    <p  className="hmwwdp"></p>
               
                    <p className='hmsecondboxdescription'>
                        
                    "At first we were solely about bridging a gap between those in need of funds and those who had funds but needed an opportunity to earn good returns and we were so excited serving those first clients- Until we realized that there was so much to be done in the finance space"
                         
                         </p>
                    </div>

                    {/* <div className='col-md-5 formobileonly'>
                <iframe className="img-fluid hmytvideo" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div> */}

               
                
            </Row>
        {/* </Container> */}
        </div>
    </div>

    <div className='hmfourthbox'>
    <div className=''>

            <Row>
        

                    <div className='col-lg-5 col-md-12'>
                  
                    <img class="img-fluid formobileonly"   src="images/history.jpg"/> 
                       <div class="divinvestments">
                        <p className="hmciahead">Our Mission</p>
                        <p  className='hmfourthboxinner'>
                        Breaking barriers  to be Africas biggest financial partner in asset base through professionalism, innovation and providing premium value for our customers.                          
                            </p>
                            </div>

                            <div class="divinvestments2">
                            <p className="hmciahead">Our Vision</p>
                        <p  className='hmfourthboxinner'>
                        To become africas most reliable financial partner                      
                            </p>
                            </div>

                       
                    </div>
                    <div className='col-md-1'></div>
                    <div className='col-md-5 hideipad'>
     

        {/* <p className='hmcia formobileonly'>C
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p> */}
                <img class="img-fluid fordesktoponly"   src="images/mission.jpeg"/> 
                    </div>
             

                 
               
               
                
            </Row>

     
   
        </div>
    </div> 

    <div class="hmfourthbox">
    <Row>
                <div className='col-lg-5 col-md-5 hideipad'>
      
                <img class="img-fluid"   src="images/values.jpeg"/> 
   
                    </div>
                    <div className='col-lg-1 col-md-1'></div>

                    <div className='col-lg-6 col-md-12 blogmobile'>
                    <p className='hmcia titlemobile'>The
       <span style={{color:"#D80032"}} > values </span> that makes us stand out
        
        </p>
     

        {/* <p className='hmcia formobileonly'>C
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p> */}
        <p  className="hmwwdp"></p>
        <p  className='hmfourthboxinner '>
        Our values define everything we do, they are the principles that guide our professional and personal conduct. These principles remain at the core of Rich-Oak, ensuring we achieve excellence in all our businesses.
                       
                            </p>
                       {/* <img class="img-fluid" src="images/credit.png"/> */}
                       <div class="divinvestmentss">
                        {/* <p className="hmciahead">Pre-start up advisory services</p> */}
                        <div class="row">
                            <div class="col-md-6 col-6">
                            <p  className='hmfourthboxinner3'><img  style={{paddingRight:"15px"}} src="./images/check2.png"/>  Professionalism </p>
                        <p  className='hmfourthboxinner3'><img style={{paddingRight:"15px"}}  src="./images/check2.png"/>  Speed </p>
                        <p  className='hmfourthboxinner3'><img style={{paddingRight:"15px"}}  src="./images/check2.png"/>  Innovation </p>
                        <p  className='hmfourthboxinner3'><img style={{paddingRight:"15px"}}  src="./images/check2.png"/>  Integrity </p>


                            </div>

                            <div class="col-md-6 col-6">
                        <p  className='hmfourthboxinner3'><img style={{paddingRight:"15px"}}  src="./images/check2.png"/>  Consistency </p>
                        <p  className='hmfourthboxinner3'><img style={{paddingRight:"15px"}}  src="./images/check2.png"/>  Team Work </p>
                        <p  className='hmfourthboxinner3'><img style={{paddingRight:"15px"}}  src="./images/check2.png"/>  Respect </p>

                        {/* <p  className='hmfourthboxinner'><img style={{paddingRight:"15px"}}  src="./images/check.png"/>  Respect </p> */}

                                </div>
                                <div class="col-md-12 col-12">
                                <p  className='hmfourthboxinner3'><img  style={{paddingRight:"15px"}} src="./images/check2.png"/>  Employee Satisfaction </p>
                                <p  className='hmfourthboxinner3'><img style={{paddingRight:"15px"}}  src="./images/check2.png"/>  Customer Obsession </p>

                                </div>
                        </div>
                   

                            </div>

            
                          
                    </div>

        

                 
               
               
                
            </Row>
    </div>





    <Subfooter/>

    </div>

<div id="homepagethirdbox">
    

</div>






    <Footer/>
    </div>


    )
    
    
}


export {Firm as default}